import { useState } from 'react'
import { Grid, Button, Typography } from '@mui/material'

import useStyles from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { AccountOverrideUrlModal } from './account-override-url-modal'

interface IProps {
  accountId: string
  url: string | null
  lngCode: string
}

export const UpdateAccountQrLink = ({ accountId, url, lngCode }: IProps) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleClose = () => setOpen(false)

  const handleUpdateClick = () => setOpen(true)

  return (
    <>
      <Grid item>
        <Button className={classes.cardButton} onClick={handleUpdateClick} variant="outlined">
          <Typography className={classes.buttonText}>
            <HelperWrapper t="override-button-text" verticalPosition={12} isColorInherited />
          </Typography>
        </Button>
      </Grid>
      <AccountOverrideUrlModal
        url={url}
        accountId={accountId}
        onClose={handleClose}
        open={open}
        lngCode={lngCode}
      />
    </>
  )
}
